import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import { AnimatedHeading } from '../../shared/TextFx';
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

import TiltCard from "./TiltCard";

import blogImage1 from "./../../assets/home-blog-img1.jpg";
import blogImage2 from "./../../assets/home-blog-img2.jpg";
import blogImage3 from "./../../assets/home-blog-img3.jpg";
import AnimatedText from "./AnimatedText";
import "./style.scss";
const HomeBlog = () => {
  return (
    <section className="esq-blog-sec">
      <div className="container-fluid common-container-fluid">
        <div className="row align-items-center esq-blog-sec__header">
          <div className="col-lg-8 col-md-7 col-12">
            <AnimatedHeading className="h-display esq-blog-sec__title" text="WHY ESQUIRE" />

          </div>

        </div>

        <div className="row" data-aos="fade-up">
          <div className="col-12">
            <Swiper
              modules={[Navigation, Pagination, Autoplay]}
              spaceBetween={30}
              slidesPerView={1}
              navigation={false}
              pagination={{ clickable: true }}
              autoplay={{ delay: 5000, disableOnInteraction: false }}
              breakpoints={{
                576: { slidesPerView: 1 },
                768: { slidesPerView: 2 },
                992: { slidesPerView: 3 },
              }}
              className="esq-blog-sec__swiper"
            >
              {/* Slide 1 */}
              <SwiperSlide>
                <TiltCard className="esq-blog-card">
                  <div className="esq-blog-card__img-wrap">
                    <img
                      src={blogImage1}
                      alt="Faster Air Freight"
                      className="esq-blog-card__img"
                    />
                    {/* <span className="esq-blog-card__date">11 Jul 2026</span> */}
                  </div>
                  <div className="esq-blog-card__body">
                    <h3 className="esq-blog-card__title common-section-title-h3">
                      Human Oversight
                    </h3>
                    <p className="esq-blog-card__desc">
                      Critical shipments are actively coordinated by people, not left inside an automated tracking workflow.
                    </p>

                  </div>
                </TiltCard>
              </SwiperSlide>

              {/* Slide 2 */}
              <SwiperSlide>
                <TiltCard className="esq-blog-card">
                  <div className="esq-blog-card__img-wrap">
                    <img
                      src={blogImage2}
                      alt="Safe Cargo Packaging"
                      className="esq-blog-card__img"
                    />
                    {/* <span className="esq-blog-card__date">11 Jul 2026</span> */}
                  </div>
                  <div className="esq-blog-card__body">
                    <h3 className="esq-blog-card__title common-section-title-h3">
                      Deadline First Routing
                    </h3>
                    <p className="esq-blog-card__desc">
                      The deadline comes first. We build the route around it.
                    </p>

                  </div>
                </TiltCard>
              </SwiperSlide>

              {/* Slide 3 */}
              <SwiperSlide>
                <TiltCard className="esq-blog-card">
                  <div className="esq-blog-card__img-wrap">
                    <img
                      src={blogImage3}
                      alt="Smart Logistics"
                      className="esq-blog-card__img"
                    />
                    {/* <span className="esq-blog-card__date">12 Jul 2026</span> */}
                  </div>
                  <div className="esq-blog-card__body">
                    <h3 className="esq-blog-card__title common-section-title-h3">
                      One Point of Accountability
                    </h3>
                    <p className="esq-blog-card__desc">
                      From pickup through delivery, our 24/7 Control Tower coordinates every stage and remains accountable throughout.
                    </p>

                  </div>
                </TiltCard>
              </SwiperSlide>
            </Swiper>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HomeBlog;